import React from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  FactsetButton,
  IrwinFactsetLogo,
  Paper,
  Typography,
} from '@the-platform-group/component-library'

/**
 * Full-page FactSet sign-in interstitial shown when the user needs to authenticate with FactSet.
 * @param {object} props - Component props
 * @param {string} props.message - Prompt text displayed above the sign-in button
 * @param {Function} props.onSignIn - Called when the user clicks the FactSet sign-in button
 * @returns {React.ReactElement} The auth interstitial page
 */
function AuthInterstitial({ message, onSignIn }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        bgcolor: 'factset.primary.light',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper
        elevation={24}
        sx={{
          px: 3,
          py: 8,
          textAlign: 'center',
          width: theme => theme.spacing(54.5),
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
            <Box
              component="img"
              src={IrwinFactsetLogo}
              alt="Irwin + Factset"
              sx={{ height: theme => theme.spacing(7.5), width: 'auto' }}
            />
            <Typography variant="h5">{message}</Typography>
          </Box>
          <FactsetButton logoColor="white" onClick={onSignIn}>
            Sign in with FactSet
          </FactsetButton>
        </Box>
      </Paper>
    </Box>
  )
}

AuthInterstitial.propTypes = {
  message: PropTypes.string.isRequired,
  onSignIn: PropTypes.func.isRequired,
}

export default AuthInterstitial
